/** @format */

import React from 'react';
import ViewListIcon from '@mui/icons-material/ViewList';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import intl from 'react-intl-universal';
import Grid from 'src/ui/library/Grid/Grid';
//import classNames from 'classnames';
import PercentageCircle from 'src/ui/library/PercentageCircle';

import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const goldColor = '#f5a623';
const greenColor = '#2eb757';

function QuestionnaireTopHeader({
  title,
  onSave,
  onClose,
  isWithinCaseDetails,
  data,
  overallProgress,
  isDataPage,
  hideSaveCloseNotice,
}) {
  const breadcrumbWidth = isDataPage ? 4 : hideSaveCloseNotice ? 12 : 6;
  return (
    <div>
      <Grid container className="breadCrumb-menu" alignItems="center">
        <Grid item xs={breadcrumbWidth} sm={breadcrumbWidth}>
          <div role="presentation" className="breadCrumb-link">
            <Link component="button" underline="hover" color="inherit" className="breadcrumHomeLink" onClick={onClose}>
              <ViewListIcon />
              {intl.get('questionnaire.actionBar.caseview')}
            </Link>
            <NavigateNextIcon fontSize="small" className="seperator" />
            <Typography color="text.primary" className="questionaireTitle">
              {title}
            </Typography>
          </div>
        </Grid>
        {!hideSaveCloseNotice && (
          <Grid item xs={isDataPage ? 5 : 6} sm={isDataPage ? 6 : 6}>
            <div className="questionnaire-save-notice">
              <InfoOutlined className="notice-icon" />
              <span className="notice-text">{intl.get('questionnaire.actionBar.saveCloseNotice')}</span>
            </div>
          </Grid>
        )}
        {isDataPage && (
          <Grid item xs={3} sm={2}>
            <div className="QuestionnaireTopCircleHeader">
              <PercentageCircle
                color={overallProgress === 100 ? greenColor : goldColor}
                percent={overallProgress}
                radius={34}
                borderWidth={5}>
                <div className="circle-inner-text">
                  <div className={'percentage circle-font-size'}>{overallProgress}%</div>
                  <span className="text">{intl.get('questionnaire.overall')}</span>
                </div>
              </PercentageCircle>
            </div>
          </Grid>
        )}
      </Grid>
      {/*
      {isDataPage && (
        <div className="questionnaire-save-header">
            <span onClick={onSave}>
              <span className="save-icon">
                <SaveIcon titleAccess={intl.get('questionnaire.actionBar.save')} className="icon md blue" />
              </span>
            </span>
        </div>
      )}
       <div
        className={classNames({
          'questionnaire-top-header': false,
          'is-within-case-details': isWithinCaseDetails,
        })}>
        <Grid container>
          <Grid item xs={9} className="mobile-page-header">
            <b className="show-mobile page-title">{title}</b>
          </Grid>
          <Grid item xs={3}>
            {!isWithinCaseDetails && (
              <div className="questionnaire-mobile-header show-mobile-flex">
                <div className="overall-progress-circle">
                  <PercentageCircle
                    color={overallProgress === 100 ? greenColor : goldColor}
                    percent={overallProgress}
                    radius={35}
                    borderWidth={5}>
                    <div className="circle-inner-text">
                      <div className={'percentage circle-font-size'}>{overallProgress}%</div>
                      <span className="text">{intl.get('questionnaire.overall')}</span>
                    </div>
                  </PercentageCircle>
                </div>
              </div>
            )}
          </Grid>
          {isWithinCaseDetails && (
            <Grid item xs={2} className="close-icon">
              <CloseIcon onClick={onClose} />
            </Grid>
          )}

        </Grid>
      </div>
      } */}
    </div>
  );
}

export default QuestionnaireTopHeader;
